import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Dropdown from 'react-bootstrap/lib/Dropdown';
import MenuItem from 'react-bootstrap/lib/MenuItem';

import i18n from '../../i18n';

import {
  selectLanguages,
  selectLanguage
} from '../../selectors';

import {
  setLanguage
} from 'actions';

import 'flag-icon-css/css/flag-icon.css';

const LanguageShape = PropTypes.shape({
  value: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  flag: PropTypes.string.isRequired
});

class LanguageSwitcher extends Component {
  static propTypes = {
    language: LanguageShape.isRequired,
    languages: PropTypes.arrayOf(LanguageShape).isRequired,
    setLanguage: PropTypes.func.isRequired
  };

  state = {
    isSmallScreen: false
  };

  handleMenuItemSelect = key => {
    this.props.setLanguage(key);
  }

  // Moment syncing stuff was moved to i18n itself
  // Still this should be in middleware (What if any other component dipatches language change)
  syncLanguage({ value }) {
    i18n.changeLanguage(value);
  }

  componentWillMount() {
    this.syncLanguage(this.props.language);
  }

  componentDidMount() {
    this.setState({
      isSmallScreen: window.innerWidth < 480
    });
  }

  componentWillReceiveProps({language}) {
    const {
      language: prevLanguage
    } = this.props;

    if (language !== prevLanguage) {
      this.syncLanguage(language);
    }
  }

  render() {
    const {
      languages,
      language,
      setLanguage
    } = this.props;

    return (
      <Dropdown pullRight={this.state.isSmallScreen} id="LanguageSwitcher" className="language-select">
        <Dropdown.Toggle noCaret>
          <span className={`flag-icon flag-icon-${language.flag}`} />

          <span className="visible-lg-inline">{language.title}</span>

          <span className="dropdown-toggle-icon">
            <span className="caret" />
          </span>
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {languages.map(el =>
            <MenuItem
              key={el.value}
              eventKey={el.value}
              active={el === language}
              onSelect={setLanguage}
            >
              {el.title}
            </MenuItem>
          )}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}


export default connect(
  state => ({
    language: selectLanguage(state),
    languages: selectLanguages(state)
  }),
  {
    setLanguage
  }
)(LanguageSwitcher);



// WEBPACK FOOTER //
// ./src/components/Header/LanguageSwitcher.js